var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.000000pt",
    height: "17.000000pt",
    viewBox: "0 0 820.000000 820.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,820.000000) scale(0.100000,-0.100000)",
    fill: "#7a7a7a",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4694 6815 c-392 -58 -749 -235 -1037 -514 -311 -301 -503 -672 -563 -1088 -22 -156 -15 -467 14 -602 35 -159 81 -307 144 -464 l60 -150 -971 -971 -971 -971 0 -343 0 -342 680 0 680 0 0 340 0 340 345 0 345 0 0 340 0 340 337 0 338 0 206 206 206 206 99 -21 c164 -35 231 -42 378 -42 640 2 1255 364 1592 938 247 418 318 923 199 1395 -132 519 -507 982 -989 1221 -196 97 -409 163 -606 187 -114 14 -374 11 -486 -5z m890 -681 c264 -68 442 -344 382 -597 -32 -135 -111 -248 -227 -326 -305 -204 -727 -7 -778 362 -21 156 31 302 153 422 133 132 302 182 470 139z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/customIcon.306ff910.svg";
export { ForwardRef as ReactComponent };